import { useIntl } from 'react-intl';
import React from 'react';
import { useErrorDisplayContext } from '../../context';
import { SubmissionError } from '../SubmissionError';
import styles from './ReportEventFormContent.module.scss';

export const ReportEventFormContent = (props: {
    children: React.ReactNode;
}) => {
    const { children } = props;
    const { error, setError } = useErrorDisplayContext();
    const intl = useIntl();
    const formDescription = intl.formatMessage({
        id: "Please help Eventbrite investigate this event by providing information about why you're reporting it.",
        defaultMessage: "Please help Eventbrite investigate this event by providing information about why you're reporting it.",
    });
    const errorMessage = intl.formatMessage({
        id: 'There was an error submitting the report.',
        defaultMessage: 'There was an error submitting the report.',
    });
    const formTitle = intl.formatMessage({
        id: 'Reason For Report',
        defaultMessage: 'Reason For Report',
    });
    return (
        <div className={styles.formContainer}>
            <p className={styles.formDescription}>{formDescription}</p>
            <SubmissionError
                hasError={error || false}
                onClose={() => setError?.(false)}
                data-testid="form-submission-error"
                containerClassName={`error-notification ${styles.errorContainer}`}
            >
                {errorMessage}
            </SubmissionError>
            {/* TODO: allow enter to trigger `handleSubmit` encapsulated in `ReportEventFormFields.tsx` */}
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                }}
            >
                <p className={styles.formTitle}>{formTitle}</p>
                {children}
            </form>
        </div>
    );
};
